import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-checker-it-facility',
  templateUrl: './checker-it-facility.component.html',
  styleUrls: ['./checker-it-facility.component.scss']
})
export class CheckerItFacilityComponent implements OnInit {
public Checker_itfacility_edit:any[]=[];
  constructor(public appservice:AppService,public router:Router,public location:Location,public Toastr:ToastrService) { }
public checkerData:any={};
back(){
this.location.back();
}
onApprove(){
  this.checkerData.status='Approved';
  this.checkerData.approvedby=this.appservice.username;
   this.appservice.getTable("api/Transaction/update_checkeritfacility?empid="+this.checkerData.OD_EmployeeID+"&status="+this.checkerData.status+"&username="+this.checkerData.approvedby).subscribe((res:any)=>{
    this.Toastr.success("Approved successfully!");
    this.appservice.getcheckerITfacilitygrid();
   });
  this.appservice.checkeritfacilityedit='';
   this.appservice.goback();
}
onDecline(){
  if(this.checkerData.command==undefined || this.checkerData.command==''){
    this.Toastr.error("Please enter the reason for rejection!");
    return;
  }
  this.checkerData.status='Rejected';
    this.checkerData.approvedby=this.appservice.username;
    this.appservice.getTable("api/Transaction/update_checkeritfacility?empid="+this.checkerData.OD_EmployeeID+"&status="+this.checkerData.status+"&username="+this.checkerData.approvedby).subscribe((res:any)=>{
  this.Toastr.success("Rejected successfully!");
    this.appservice.getcheckerITfacilitygrid();
    });
  this.appservice.goback();
}
getchecker_itfacility_edit(data:any){
   this.appservice.getTable("api/Transaction/getchecker_itfac_editdata?empid="+this.appservice.checkeritfacilityedit).subscribe((res:any)=>{
    this.Checker_itfacility_edit=JSON.parse(res).record;
    if(this.Checker_itfacility_edit && this.Checker_itfacility_edit.length>0){
      let emp = this.Checker_itfacility_edit[0];
      this.checkerData.OD_EmployeeID=emp.IR_EmployeeId;
      this.checkerData.Fullname=emp.IR_Fullname;
      this.checkerData.Username=emp.IR_ADUserName;
      this.checkerData.Mailid=emp.IR_ADMailId;
      this.checkerData.Designation=emp.IR_Designation;
      this.checkerData.grade=emp.IR_Grade;
      this.checkerData.department=emp.IR_Department;
      this.checkerData.AssertType= emp.IR_AssertType;
      this.checkerData.DriveAccess=emp.IR_NacDriver_Access;
      this.checkerData.Dongle=emp.IR_Dongle_SimCard;
      this.checkerData.MSimcard=emp.IR_Mobilesim;
      this.checkerData.Biometric=emp.IR_Biometric_card;
      this.checkerData.DoorAccess=emp.IR_DoorAccess;
      this.checkerData.Other=emp.IR_Other;
    }
   })
}
  ngOnInit(): void {
    this.getchecker_itfacility_edit(this.appservice.checkeritfacilityedit)
  }

}
